export enum CalendarView {
	TIMELINE_DAY = 'resourceTimelineDay',
	TIMELINE_WEEK = 'resourceTimelineWeek',
	TIMELINE_MOTH = 'resourceTimelineMonth',
	LIST_WEEK = 'listWeek',
	TIME_GRID_DAY = 'timeGridDay',
	TIME_GRID_WEEK = 'timeGridWeek',
	DAY_GRID_MONTH = 'dayGridMonth',
}
